import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../environments/environment";
import {Router} from "@angular/router";


@Injectable()
export class AuthService {
  jwtAuthToken = localStorage.getItem('authToken');
  nickname = localStorage.getItem('nickname');

  constructor(
    private httpService: HttpClient,
    private router: Router,
    ) {
  }

  async signIn(nickname: string, password: string, token: string) {
    try {
      const result = await this.httpService.post(environment.apiUrl + '/auth/sign-in', {
        nickname,
        password,
        token,
      }).toPromise();

      this.jwtAuthToken = (result as any).token;
      localStorage.setItem('authToken', this.jwtAuthToken as string);
      localStorage.setItem('nickname', nickname);
      this.nickname = nickname;

      if ((result as any).goDashboard) {
        const tm = setTimeout(() => {
          this.router.navigate(['dashboard/index']).catch(console.error);
          clearTimeout(tm);
        }, 2000);

        // @ts-ignore
        const badge = document.querySelector('.grecaptcha-badge');
        if (badge) (badge as any).style.display = 'none';
      }

      return result;
    } catch (err) {
      console.error(this, environment, err);
    }

    return null;
  }
  async singInFinal(code: string) {
    try {
      const result = await this.httpService.post(environment.apiUrl + '/auth/tfa', {
        code
      }, {
        headers: {
          'Authorization': 'Bearer ' + this.jwtAuthToken,
        }
      }).toPromise();

      this.jwtAuthToken = (result as any).token;
      localStorage.setItem('authToken', this.jwtAuthToken as string);

      this.router.navigate(['dashboard/index']).catch(console.error);
      // @ts-ignore
      const badge = document.querySelector('.grecaptcha-badge');
      if (badge) (badge as any).style.display = 'none';

      return result;
    } catch (err) {
      console.error(this, err);
    }

    return null;
  }
  async reset(nickname: string) {
    try {
      const result = await this.httpService.post(environment.apiUrl + '/auth/reset', {
        nickname,
      }).toPromise();

      const success = (result as any).status;

      return success;
    } catch (err) {
      console.error(this, err);
    }

    return null;
  }
  async nwPassword(code: string) {
    try {
      const result = await this.httpService.post(environment.apiUrl + '/auth/nw-password', {
        code,
      }).toPromise();

      const success = (result as any).status;

      return success;
    } catch (err) {
      console.error(this, err);
    }

    return null;
  }

  async logout() {
    localStorage.removeItem('jwtToken');


    this.jwtAuthToken = null;

    this.router.navigate(['auth/login']).catch(console.error);

  }

}
